import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { AnalyticsService } from './shared/services/analytics/analytics.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    constructor(private router: Router, private analytics: AnalyticsService) {
        this.router.events
            .pipe(
                filter(
                    (e): e is NavigationEnd => e instanceof NavigationEnd, // Type guard
                ),
            )
            .subscribe((e) => {
                this.analytics.trackPage(e.urlAfterRedirects);
            });
    }
}
